class ShareToast extends HTMLElement {
  constructor() {
    super();
    this.isShowing = false;
    this.hideTimeout = null;
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        share-toast {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%) translateY(100px);
          z-index: 9999;
          pointer-events: none;
          opacity: 0;
          transition: all 0.3s ease-in-out;
        }

        share-toast.show {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }

        .share-toast__container {
          background: #333;
          color: white;
          padding: 1rem 1.5rem;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 0.9375rem;
          min-width: 250px;
          max-width: 90vw;
        }

        .share-toast__icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        .share-toast__icon svg {
          width: 100%;
          height: 100%;
          fill: currentColor;
        }

        .share-toast__text {
          flex: 1;
          text-align: center;
        }

        @media (max-width: 480px) {
          share-toast {
            bottom: 1rem;
          }
          
          .share-toast__container {
            padding: 0.875rem 1.25rem;
            font-size: 0.875rem;
          }
        }
      </style>
      <div class="share-toast__container">
        <div class="share-toast__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>
          </svg>
        </div>
        <div class="share-toast__text">Wishlist link copied to clipboard!</div>
      </div>
    `;
  }

  show(message = 'Wishlist link copied to clipboard!') {
    if (this.isShowing) {
      clearTimeout(this.hideTimeout);
    }

    // Update message if provided
    const textElement = this.querySelector('.share-toast__text');
    if (textElement && message) {
      textElement.textContent = message;
    }

    // Show the toast
    this.classList.add('show');
    this.isShowing = true;

    // Auto hide after 3 seconds
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, 3000);
  }

  hide() {
    this.classList.remove('show');
    this.isShowing = false;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }
}

// Define custom element
if (!customElements.get('share-toast')) {
  customElements.define('share-toast', ShareToast);
}

// Create global instance
if (!window.shareToast) {
  window.shareToast = document.createElement('share-toast');
  document.body.appendChild(window.shareToast);
}